import qs from 'qs';
import client from './client';

export default {
  async getResource() {
    const response = await client.get('dashboard/resource/');
    return response.data;
  },

  async getSection(resourceId) {
    const response = await client.get(`dashboard/resource/${resourceId}/section/`);
    return response.data;
  },

  async getVideo(sectionId) {
    const response = await client.get(`dashboard/section/${sectionId}/video/`);
    return response.data;
  },

  async getDownloadable(sectionId) {
    const response = await client.get(`dashboard/section/${sectionId}/downloadable/`);
    return response.data;
  },

  async downloadResources(params) {
    const response = await client.get(`dashboard/downloadable/${qs.stringify(params, { addQueryPrefix: true })}`);
    return response.data;
  },
};
